type Props = {
  /** Höhe in px. 36 = Tool-Header (siehe DESIGN.md §5.6). */
  height?: number;
  className?: string;
};

export function Logo({ height = 36, className }: Props) {
  return (
    <img
      src="/brand/tro_logo_pos.svg"
      alt="TRO"
      height={height}
      style={{ height: `${height}px`, width: 'auto', display: 'block' }}
      className={className}
    />
  );
}
